<template>
  <RouterView />
</template>

<script setup lang="ts">
import { watch } from 'vue';
import {
  RouterView, useRoute
} from 'vue-router'
import { useHtmlMetaFunc } from './utils/htmlmeta';
import { useUrlFunc } from './utils/url';

const route = useRoute()
const htmlMetaFunc = useHtmlMetaFunc()
const url = useUrlFunc()

url.saveS(undefined)

watch(() => route.fullPath, () => {
  htmlMetaFunc.setDescription(route.meta.description)
  htmlMetaFunc.setTitle(route.meta.title)
})
</script>

<style lang="scss">

// 横スクロールバー分の高さが出てくるものを修正
html,
body,
#app {
  height: 100%;

  .v-application,
  .v-application__wrap {
    height: 100%;
    min-height: auto;
  }
}
.tg-backdrop {
  z-index: 9999 !important;
  border: none !important;
}
.dp__theme_light {
  --dp-border-color: #ababab !important;
  --dp-border-color-hover: rgb(118, 118, 118) !important;
}
</style>
